var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg0(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    fill: "#000000",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M412 484m-17.6 0a17.6 17.6 0 1 0 35.2 0 17.6 17.6 0 1 0-35.2 0Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M401.6 484c0 5.6 4.8 10.4 10.4 10.4s10.4-4.8 10.4-10.4c0-5.6-4.8-10.4-10.4-10.4s-10.4 4-10.4 10.4z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M478.4 484m-17.6 0a17.6 17.6 0 1 0 35.2 0 17.6 17.6 0 1 0-35.2 0Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M468 484c0 5.6 4.8 10.4 10.4 10.4s10.4-4.8 10.4-10.4c0-5.6-4.8-10.4-10.4-10.4s-10.4 4-10.4 10.4zM545.6 501.6c-9.6 0-17.6-8-17.6-17.6s8-17.6 17.6-17.6c9.6 0 17.6 8 17.6 17.6s-8 17.6-17.6 17.6z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M534.4 484c0 5.6 4.8 10.4 10.4 10.4 5.6 0 10.4-4.8 10.4-10.4s-4.8-10.4-10.4-10.4c-5.6-0.8-10.4 4-10.4 10.4z",
    fill: ""
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M612 484m-17.6 0a17.6 17.6 0 1 0 35.2 0 17.6 17.6 0 1 0-35.2 0Z",
    fill: ""
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M601.6 484c0 5.6 4.8 10.4 10.4 10.4 5.6 0 10.4-4.8 10.4-10.4s-4.8-10.4-10.4-10.4c-5.6-0.8-10.4 4-10.4 10.4zM656.8 881.6c-12 0-24-3.2-34.4-9.6-30.4-19.2-40-59.2-20.8-88.8 12-19.2 32.8-30.4 55.2-30.4 12 0 24 3.2 34.4 9.6 14.4 8.8 24.8 23.2 28.8 40s0.8 34.4-8 48.8c-12 19.2-32 30.4-55.2 30.4z m-20-28.8c5.6-8 18.4-26.4 23.2-34.4 4.8-7.2 15.2-27.2 20-36l-0.8-0.8-1.6-0.8c-5.6 8-18.4 26.4-23.2 34.4-4.8 7.2-15.2 27.2-20 36l0.8 0.8 1.6 0.8z",
    fill: ""
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M688 768c-27.2-16.8-62.4-8.8-79.2 18.4s-8.8 62.4 18.4 79.2 62.4 8.8 79.2-18.4c16.8-26.4 8.8-62.4-18.4-79.2z m-48.8 93.6l-8-2.4-5.6-6.4s16.8-31.2 23.2-40.8 26.4-38.4 26.4-38.4l8 2.4 5.6 6.4s-16.8 31.2-23.2 40.8c-5.6 9.6-26.4 38.4-26.4 38.4zM366.4 881.6c-9.6 0-18.4-1.6-26.4-5.6-16-7.2-28-20-33.6-36s-5.6-33.6 1.6-49.6c10.4-23.2 33.6-38.4 59.2-38.4 9.6 0 18.4 1.6 26.4 5.6 32.8 14.4 47.2 52.8 32 85.6-10.4 24-33.6 38.4-59.2 38.4z m-15.2-26.4c4.8-8.8 15.2-28.8 18.4-36.8 4-8 12-28.8 15.2-38.4l-0.8-0.8h-1.6c-4.8 8.8-15.2 28.8-18.4 36.8-4 8-12 28.8-15.2 38.4l1.6 0.8h0.8z",
    fill: ""
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M390.4 764.8c-28.8-12.8-63.2 0-76.8 28.8-12.8 28.8 0 63.2 28.8 76.8 28.8 12.8 63.2 0 76.8-28.8 13.6-29.6 0.8-64-28.8-76.8z m-35.2 98.4l-8-1.6-6.4-5.6s12.8-32.8 17.6-43.2c4.8-10.4 21.6-41.6 21.6-41.6l8 1.6 6.4 5.6s-12.8 32.8-17.6 43.2c-5.6 10.4-21.6 41.6-21.6 41.6z",
    fill: ""
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M588 1011.2c-5.6 0-10.4-4.8-10.4-10.4v-11.2H446.4v11.2c0 5.6-4.8 10.4-10.4 10.4H323.2c-5.6 0-10.4-4.8-10.4-10.4v-11.2H232c-24 0-43.2-19.2-43.2-43.2V71.2c0-24 19.2-43.2 43.2-43.2h154.4v-4.8c0-5.6 4.8-10.4 10.4-10.4h230.4c5.6 0 10.4 4.8 10.4 10.4v4H792c24 0 43.2 19.2 43.2 43.2v874.4c0 24-19.2 43.2-43.2 43.2H711.2v11.2c0 5.6-4.8 10.4-10.4 10.4H588zM233.6 904c0 20 16.8 36.8 36.8 36.8h482.4c20 0 36.8-16.8 36.8-36.8V638.4H233.6V904z m556.8-284.8V112c0-20-16.8-36.8-36.8-36.8H270.4c-20 0-36.8 16.8-36.8 36.8v506.4h556.8z",
    fill: ""
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0);
export default __webpack_public_path__ + "static/media/0.bb1772e7b12f1fc8de87a7bca2143780.svg";
export { ForwardRef as ReactComponent };